/**
 * Auth Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import _ from 'lodash';

// States
const state = {
    me: {},
    loggedIn: localStorage.getItem('ms-token') != null
};

// Getters
const getters = {
    me: state => {
        return state.me
    },

    loggedIn: state => {
        return state.loggedIn
    }
};

// Actions
const actions = {
    loginHandler(context, payload) {
        function successCallback(response) {
            context.commit('loginHandlerMut', { user: response.data.user, token: response.data.access_token, expiration: response.data.token_expires_at });
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = "";

        makeApiRequest(payload.args, apiModel.Auth.Login, localToken, successCallback, errorCallback);
    },
    loginRedirectHandler(context, payload) {
        function successCallback(response) {
            context.commit('loginHandlerMut', { user: response.data.user, token: response.data.access_token, expiration: response.data.token_expires_at });
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = "";

        makeApiRequest(payload.args, apiModel.Auth.LoginAfterRedirect, localToken, successCallback, errorCallback);
    },
    oAuthLoginHandler(context, payload) {
        function successCallback(response) {
            context.commit('loginHandlerMut', { user: response.data.user, token: response.data.access_token, expiration: response.data.token_expires_at });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = "";

        makeApiRequest(payload.args, apiModel.Auth.Login, localToken, successCallback, errorCallback);
    },

    registerHandler(context, payload) {
        function successCallback(response) {
            context.commit('registerHandlerMut', { user: response.data.user, token: response.data.access_token, expiration: response.data.expires_in });
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = "";

        makeApiRequest(payload.args, apiModel.Auth.Register, localToken, successCallback, errorCallback, true);
    },

    logoutHandler(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalFileHandler', { file: {} });
            context.commit('setselectedInstitutionHandler', { selectedInstitution: {} });
            context.commit('getPatientHandler', { patient: {} });
            context.commit('clearItemsHandler', { items: [] });
            context.commit('logoutHandlerMut');
        }

        function errorCallback(error) {
            /* Vue.swal(
                error.message,
                '',
                'error'
            ); */
            localStorage.removeItem('user');
            localStorage.removeItem('unread_notifications');
            localStorage.removeItem('permissions');
            localStorage.removeItem('ms-token');
            localStorage.removeItem('token-expires-at');
            localStorage.removeItem('dashboardName');
            localStorage.removeItem('dashboardPath');
            localStorage.removeItem('role');
        }

        const localToken = localStorage.getItem('ms-token');
        payload.args.time_slug = JSON.parse(localStorage.getItem('user'))['time_slug'];
        makeApiRequest(payload.args, apiModel.Auth.Logout, localToken, successCallback, errorCallback);
    }
};

// Mutations
const mutations = {
    loginHandlerMut(state, { user, token, expiration }) {
        // Update me state
        state.me = user;

        // Update loggedIn state
        state.loggedIn = true;

        // Store user, role and token locally
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('unread_notifications', JSON.stringify(user.unread_notifications));
        localStorage.setItem('permissions', JSON.stringify(user.permissions));
        localStorage.setItem('ms-token', token);
        localStorage.setItem('token-expires-at', expiration);
        localStorage.setItem('role', user.roles[0].name);

        switch (localStorage.getItem('role')) {
            case 'Praticien':
                localStorage.setItem('dashboardName', 'PractionerDashboard');
                localStorage.setItem('dashboardPath', 'practioner-dashboard');
                break;

            case 'Admin':
                localStorage.setItem('dashboardName', 'dashboard');
                localStorage.setItem('dashboardPath', '/dashboard');

                break;

            case 'Medecin controle':
                localStorage.setItem('dashboardName', 'MedecinDashboard');
                localStorage.setItem('dashboardPath', 'medecin-dashboard');

                break;

            case 'Souscripteur':
                localStorage.setItem('dashboardName', 'SouscripteurDashboard');
                localStorage.setItem('dashboardPath', 'souscripteur-dashboard');
                break;

            // case 'Patient':
            //     localStorage.setItem('dashboardName', 'PatientDashboard');
            //     break;

            // case 'Gestionnaire':
            //     localStorage.setItem('dashboardName', 'GestionnaireDashboard');
            //     break;

            case 'Etablissement':
                localStorage.setItem('dashboardName', 'facturations');
                localStorage.setItem('dashboardPath', 'facturations');

                break;

            case 'Assistante':
                localStorage.setItem('dashboardName', 'AssistanteDashboard');
                localStorage.setItem('dashboardPath', 'assistante-dashboard');
            
                break;

            case 'Pharmacien':
                localStorage.setItem('dashboardName', 'AssistanteDashboard');
                localStorage.setItem('dashboardPath', 'assistante-dashboard');

                break;

            default:
                localStorage.setItem('dashboardName', 'dashboard');

        }

        if(localStorage.getItem('ancestor_link') != null){
            let ancestor_link = localStorage.getItem('ancestor_link');
            localStorage.removeItem('ancestor_link');
            window.location.href = ancestor_link;
        }else{
            // Check if url contains redirect parameter
            if (router.currentRoute.query.redirect != null) {
                // Redirect to intended path
                router.push({ path: router.currentRoute.query.redirect, query: router.currentRoute.query });
            } else {

                switch (localStorage.getItem('role')) {
                    case 'Praticien':
                        router.push('/practioner-dashboard');
                        break;

                    case 'Medecin controle':
                        router.push('/dashboard/medecin-dashboard');
                        break;

                    case 'Souscripteur':
                        router.push('/souscripteur-dashboard');
                        break;

                    case 'Patient':
                        router.push({ name: 'medical-file', params: { file: user.dossier } });
                        break;

                    case 'Etablissement':
                        router.push({ name: 'facturations'});
                        break;
                    
                    case 'Assistante':
                        router.push('/assistante-dashboard');
                        break;
                        

                    default:
                        // Redirect to dashboard
                        router.push("/dashboard");

                }
            }
        }
    },

    registerHandlerMut(state, { user, token, expiration }) {
        // Update me state
        state.me = user;

        // Update loggedIn state
        state.loggedIn = true;

        // Store user, role and token locally
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('unread_notifications', JSON.stringify(user.unread_notifications));
        localStorage.setItem('permissions', JSON.stringify(user.permissions));
        localStorage.setItem('ms-token', token);
        localStorage.setItem('token-expires-at', expiration);
        localStorage.setItem('role', user.roles[0].name);

        // Redirect to dashboard
        router.push("/dashboard");
    },

    logoutHandlerMut(state) {
        // Update me state
        state.me = {};

        // Update loggedIn state
        state.loggedIn = false;

        // Remove locally stored user and token
        localStorage.removeItem('user');
        localStorage.removeItem('unread_notifications');
        localStorage.removeItem('permissions');
        localStorage.removeItem('ms-token');
        localStorage.removeItem('token-expires-at');
        localStorage.removeItem('dashboardName');
        localStorage.removeItem('dashboardPath');
        localStorage.removeItem('role');

        // Redirect to login view
        window.location.href = "/login";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}